import { CombinedBranchSummary, CombinedSummary } from "./types";

function insertBranchesIntoCompany(
  combined: CombinedSummary,
  companyId: string,
  companyBranches: CombinedBranchSummary[]
) {
  const result = { ...combined };
  const branches = companyBranches
    ? [...companyBranches]
    : [
        {
          name: "Loading....",
          customers: [{ firstName: "Loading...", lastName: "" }]
        }
      ];
  result[companyId] = {
    ...result[companyId],
    branches
  };
  return result;
}

export default insertBranchesIntoCompany;
